var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"pipeline-stage"}},_vm._l((_vm.jobs),function(job){return _c('ul',{key:job.id},[_c('job-item',{attrs:{"job":job}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }